import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { BehaviorSubject, Observable, Subject, ReplaySubject } from 'rxjs';
import {
  UserDto,
  UserLoginInfoDto,
} from '@shared/service-proxies/service-proxies';

@Injectable()
export class AppStorageService {
  setGrantedPermissions(grantedPermissions: any) {
    console.debug('set GrantedPermissionsSubject');
    this._grantedPermissionsSubject.next(grantedPermissions);
  }
  setAllPermissions(allPermissions: any) {
    console.debug('set AllPermissionsSubject');
    this._allPermissionsSubject.next(allPermissions);
  }
  setUser(_user: UserLoginInfoDto) {
    console.debug('set UserSubject');
    this._userSubject.next(_user);
    this.storage.set(AppStorageService._userKey, _user);
  }
  setToken(accessToken: string, encryptedToken: string, tokenExpireDate: Date) {
    console.debug('set TokenSubject');
    this._tokenSubject.next(accessToken);
    this._encryptedTokenSubject.next(encryptedToken);
    this._isLoadedSubject.next(true);
    this.storage.set(AppStorageService._certificationTokenKey, accessToken);
    this.storage.set(
      AppStorageService._certificationEncryptedTokenKey,
      encryptedToken
    );
    this.storage.set(AppStorageService._certificationTokenExp, tokenExpireDate);
  }

  private _userSubject: Subject<UserLoginInfoDto> = new ReplaySubject(1);
  private _tokenSubject: Subject<string> = new ReplaySubject(1);
  private _encryptedTokenSubject: Subject<string> = new ReplaySubject(1);
  private _allPermissionsSubject: Subject<any> = new ReplaySubject(1);
  private _grantedPermissionsSubject: Subject<any> = new ReplaySubject(1);
  private _isLoadedSubject: Subject<boolean> = new ReplaySubject(1);

  get UserSubject(): Observable<UserLoginInfoDto> {
    return this._userSubject.asObservable();
  }

  get GrantedPermissionsSubject(): Observable<any> {
    return this._grantedPermissionsSubject.asObservable();
  }

  get TokenSubject(): Observable<string> {
    return this._tokenSubject.asObservable();
  }
  get EncryptedTokenSubject(): Observable<string> {
    return this._encryptedTokenSubject.asObservable();
  }

  get AllPermissionsSubject(): Observable<any> {
    return this._allPermissionsSubject.asObservable();
  }

  get IsLoadedSubject(): Observable<boolean> {
    return this._isLoadedSubject.asObservable();
  }

  static _certificationTokenKey: string = '_certificationTokenKey';
  static _certificationEncryptedTokenKey: string = '_certificationEncTokenKey';
  static _certificationTokenExp: string = '_certificationTokenExp';
  static _userKey: string = '_userKey';

  clearToken() {
    this.storage.remove(AppStorageService._certificationTokenKey);
    this.storage.remove(AppStorageService._certificationTokenExp);

    this._grantedPermissionsSubject.next({});
    this._tokenSubject.next(null);
    this._userSubject.next(null);
    this._isLoadedSubject.next(false);
  }
  setTenantId(tenantId: number) {
    throw new Error('Method not implemented.');
  }
  constructor(private storage: Storage) {
    this.init();
  }
  init() {
    return Promise.all([
      this.storage.get(AppStorageService._certificationTokenExp).then((e) => {
        if (e && e > new Date()) {
          this.storage
            .get(AppStorageService._certificationEncryptedTokenKey)
            .then((x) => this._encryptedTokenSubject.next(x));
          this.storage
            .get(AppStorageService._certificationTokenKey)
            .then((x) => {
              this._tokenSubject.next(x);
              this._isLoadedSubject.next(true);
            });
          this.storage
            .get(AppStorageService._userKey)
            .then((x) => this._userSubject.next(x));
        }
      }),
    ]);
  }
}
